export default {
  showClass: (state) => {
    var classes = {};


    return classes;
  },
  showLinkClass: (state, key) => {
    return (state.header.menu == key) ? 'active' : '';
  },
  showImage: (state, id) => {
    var image = _.find(state.header.images, (v) => {return v.key == id;});

    if(!image) return {};

    return {
      left: `${image.x + 5}px`,
      top: `${image.y - 10}px`,
      display: (image.active) ? 'block' : 'none'
    };
  },
  getSearchActive: (state) => {
    return state.header.search_active;
  }
} 